import React from "react"
import { TrendingUp } from "lucide-react"
import { Link } from "react-router-dom"
import type { DashboardStat } from "../types"
import "./DashboardStatCard.style.scss"

interface DashboardStatCardProps {
  stat: DashboardStat
}

const DashboardStatCard = ({ stat }: DashboardStatCardProps) => {
  const Icon = stat.icon

  return (
    <Link
      to={stat.to}
      className={`dashboard-stat-card is-${stat.iconTone}`}
    >
      <div className="dashboard-stat-card__top">
        <div className="dashboard-stat-card__icon" aria-hidden>
          <Icon size={18} />
        </div>
        <span className="dashboard-stat-card__trend-chip">
          <TrendingUp size={12} />
        </span>
      </div>
      <div className="dashboard-stat-card__body">
        <h4>{stat.value}</h4>
        <p>{stat.title}</p>
        {stat.trend ? <span>{stat.trend}</span> : null}
      </div>
    </Link>
  )
}

export default DashboardStatCard
